<template>
  <v-layout v-if="ready" row wrap>
    <v-flex v-bind="fieldGroup.attrs">
      <v-layout :align-end="checkIfAlignEnd(fieldGroup)" justify-start row fill-height wrap>
        <template v-for="(field, f) in fieldGroup.fields">
          <input
            :key="f"
            v-if="field.type == 'hidden'"
            type="hidden"
            v-model="formData[field.name]"
            @input="$emit('input', formData)"
          />

          <v-flex v-else :key="f" v-bind="field.attrs">
            <template v-if="showInstructions(field, 'top')">
              <div v-html="field.instructions"></div>
            </template>
            <div
              v-if="field.type == 'htmlblock'"
              v-bind="getFieldAttrs(field)"
              :class="getFieldClass(field)"
              v-html="field.content"
            ></div>

            <v-text-field
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'text'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
              box
            ></v-text-field>

            <v-textarea
              v-validate="getFieldValidator(field)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'textarea'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
              box
            ></v-textarea>

            <aru-wysiwyg-editor
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'wysiwyg'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
            ></aru-wysiwyg-editor>

            <v-text-field
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'password'"
              :append-icon="showPassword[field.name] ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="showPassword[field.name] ? 'text' : 'password'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
              @click:append="
                $set(
                  showPassword,
                  field.name,
                  showPassword.hasOwnProperty(field.name) ? !showPassword[field.name] : true,
                )
              "
              box
            ></v-text-field>

            <aru-file-input
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'file'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :field-config="field"
              box
            ></aru-file-input>

            <aru-entity-select
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'entity-select' && field.entity"
              v-model="formData[field.name]"
              :entity="field.entity"
              v-bind="getFieldAttrs(field)"
              :inputCssClass="getFieldClass(field)"
              @input="$emit('input', formData)"
              :label="$t(field.label)"
              box
            ></aru-entity-select>

            <category-select
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'category-select'"
              v-model="formData[field.name]"
              v-bind="getFieldAttrs(field)"
              :inputCssClass="getFieldClass(field)"
              @input="$emit('input', formData)"
              :label="$t(field.label)"
            ></category-select>

            <og-consultant-select
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'consultant-select'"
              v-model="formData[field.name]"
              v-bind="getFieldAttrs(field)"
              :inputCssClass="getFieldClass(field)"
              @input="$emit('input', formData)"
              box
            ></og-consultant-select>

            <og-user-select
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :label="$t(field.label)"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'user-select'"
              v-model="formData[field.name]"
              v-bind="getFieldAttrs(field)"
              :inputCssClass="getFieldClass(field)"
              @input="$emit('input', formData)"
              box
            ></og-user-select>

            <fiscal-province-selector
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :label="$t(field.label)"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'fiscal-province-selector'"
              v-model="formData[field.name]"
              v-bind="getFieldAttrs(field)"
              :inputCssClass="getFieldClass(field)"
              @input="$emit('input', formData)"
              box
            ></fiscal-province-selector>

            <v-select
              v-validate="getFieldValidator(field)"
              :attach="getFieldAttach(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'select'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
              :items="field.options"
              item-text="label"
              item-value="value"
              box
            ></v-select>

            <og-my-company-select
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'my-company-select'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :cssClass="getFieldClass(field)"
              :label="$t(field.label)"
            ></og-my-company-select>

            <aru-date-picker
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error="errors.first(field.name)"
              v-if="field.type == 'date'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
            ></aru-date-picker>

            <aru-time-picker
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'time'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
            ></aru-time-picker>

            <aru-digital-time-picker
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'digital-time'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :inputCssClass="getFieldClass(field)"
              :label="$t(field.label)"
            ></aru-digital-time-picker>

            <aru-month-picker
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'month-picker'"
              v-bind="getFieldAttrs(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              :label="$t(field.label)"
            ></aru-month-picker>

            <v-checkbox
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'checkbox'"
              v-bind="getFieldAttrs(field)"
              :color="field.color ? field.color : 'primary'"
              @input="$emit('input', formData)"
              :class="getFieldClass(field)"
              v-model="formData[field.name]"
              :label="$t(field.label)"
            ></v-checkbox>

            <template v-if="field.type == 'switch'">
              <v-switch
                v-validate="getFieldValidator(field)"
                :data-vv-as="$t(field.label)"
                :name="field.name"
                :error-messages="errors.first(field.name)"
                v-bind="getFieldAttrs(field)"
                :color="field.color ? field.color : 'primary'"
                @input="$emit('input', formData)"
                :class="getFieldClass(field)"
                v-model="formData[field.name]"
              >
                <span slot="label" v-html="getSwitchLabel(field)"></span>
              </v-switch>
            </template>
            <v-radio-group
              v-validate="getFieldValidator(field)"
              :data-vv-as="$t(field.label)"
              :name="field.name"
              :error-messages="errors.first(field.name)"
              v-if="field.type == 'radio-group'"
              v-bind="getFieldAttrs(field)"
              :color="field.color ? field.color : 'primary'"
              :class="getFieldClass(field)"
              v-model="formData[field.name]"
              @input="$emit('input', formData)"
              :label="$t(field.label)"
            >
              <div class="radio-group-options ml-3 my-3">
                <v-radio
                  v-for="(option, i) in field.options"
                  :key="i"
                  :label="getOptionLabel(option)"
                  :value="getOptionValue(option)"
                ></v-radio>
              </div>
            </v-radio-group>

            <template v-if="field.type == 'checkbox-group'">
              <div class="checkbox-group-container my-3">
                <label
                  aria-hidden="true"
                  class="v-label theme--light"
                  :class="{ 'error--text': errors.first(field.name) }"
                >
                  {{ $t(field.label) }}
                </label>
                <div class="checkbox-group-options ml-3 my-3">
                  <v-checkbox
                    v-for="(option, i) in field.options"
                    :key="i"
                    v-validate="getFieldValidator(field)"
                    :data-vv-as="$t(field.label)"
                    :name="field.name"
                    :error="errors.first(field.name)"
                    :label="getOptionLabel(option)"
                    :value="getOptionValue(option)"
                    v-bind="getFieldAttrs(field)"
                    @input="$emit('input', formData)"
                    :color="field.color ? field.color : 'primary'"
                    class="mt-0 pt-0"
                    :class="getFieldClass(field)"
                    v-model="formData[field.name]"
                  ></v-checkbox>
                  <div v-if="errors.first(field.name)" class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message">
                        {{ errors.first(field.name) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </v-flex>
        </template>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import AruDatePicker from './inputs/AruDatePicker.vue';
import AruTimePicker from './inputs/AruTimePicker.vue';
import AruDigitalTimePicker from './inputs/AruDigitalTimePicker.vue';

import AruMonthPicker from './inputs/AruMonthPicker.vue';
import AruFileInput from './inputs/AruFileInput.vue';
import AruEntitySelect from './inputs/AruEntitySelect.vue';
import OgConsultantSelect from './inputs/OgConsultantSelect.vue';
import FiscalProvinceSelector from './inputs/FiscalProvinceSelector.vue';
import OgUserSelect from './inputs/OgUserSelect.vue';
import OgMyCompanySelect from './inputs/OgMyCompanySelect.vue';
import CategorySelect from '../CategorySelect.vue';
import AruWysiwygEditor from './inputs/AruWysiwygEditor.vue';

export default {
  components: {
    AruDatePicker,
    AruMonthPicker,
    AruFileInput,
    AruEntitySelect,
    OgConsultantSelect,
    AruTimePicker,
    OgMyCompanySelect,
    CategorySelect,
    AruDigitalTimePicker,
    AruWysiwygEditor,
    OgUserSelect,
    FiscalProvinceSelector,
  },
  props: ['fieldGroup', 'value', 'defaultFieldClass', 'disabled'],
  data() {
    return {
      formData: this.value,
      ready: false,
      showPassword: {},
    };
  },
  mounted() {
    this.setInitialData();
  },
  methods: {
    getFieldAttach(field) {
      if (field.hasOwnProperty('attach')) {
        return field.attach;
      } else {
        return false;
      }
    },
    getSwitchLabel(field) {
      if (field.hasOwnProperty('label')) {
        if (this.formData[field.name] && field.hasOwnProperty('appendOn')) {
          return field.label + ' <span class="primary--text" >' + field.appendOn + '</span>';
        }
        if (!this.formData[field.name] && field.hasOwnProperty('appendOff')) {
          return field.label + ' <span class="error--text" >' + field.appendOff + '</span>';
        }
        return field.label;
      } else {
        return '';
      }
    },
    getFieldValidator(field) {
      if (field.hasOwnProperty('validation')) {
        return field.validation;
      } else {
        return '';
      }
    },
    showInstructions(field, place = 'top') {
      if (!field.hasOwnProperty('showInstructions') || !field.hasOwnProperty('instructions')) {
        return false;
      }

      return field.showInstructions && field.showInstructions === place;
    },
    setInitialData() {
      this.ready = false;

      if (Array.isArray(this.fieldGroup.fields)) {
        this.fieldGroup.fields.forEach(field => {
          // this.formData.append(field.name, field['value'] ? field['value'] : null);

          if (this.formData.hasOwnProperty(field.name) && this.formData[field.name]) {
            this.$set(
              this.formData,
              field.name,
              this.formData[field.name] ? this.formData[field.name] : null,
            );
          } else if (field.hasOwnProperty('name') && field.name) {
            if (field.hasOwnProperty('type') && field.type === 'checkbox-group') {
              this.$set(this.formData, field.name, field['value'] ? field['value'] : []);
            } else {
              this.$set(this.formData, field.name, field['value'] ? field['value'] : null);
            }
          }
        });
      }
      this.$emit('input', this.formData);
      this.ready = true;
    },
    getFieldClass(field) {
      return field['class'] ? field['class'] : this.defaultFieldClass ? this.defaultFieldClass : '';
    },

    checkIfAlignEnd(fieldGroup) {
      if (fieldGroup.hasOwnProperty('alignEnd')) {
        return fieldGroup.alignEnd;
      } else {
        return true;
      }
    },
    getFieldAttrs(field) {
      const res = field['fieldAttrs'] ? field['fieldAttrs'] : {};
      if (this.disabled) {
        res.disabled = true;
      }
      return res;
    },
    getOptionLabel(option) {
      if (option.hasOwnProperty('label')) {
        return option.label;
      } else {
        return option;
      }
    },
    getOptionValue(option) {
      if (option.hasOwnProperty('value')) {
        return option.value;
      } else {
        return option;
      }
    },
  },
  watch: {
    // formData: {
    //   handler: function(newValue) {
    //     this.$emit("input", this.formData);
    //   },
    //   deep: true
    // },
    // value: function(val) {
    //   this.formData = val;
    //   this.setInitialData();
    // }
  },
};
</script>

<style></style>
